var map = {
	"./blason-secondary.png": 31,
	"./blason.png": 32,
	"./flags/be.svg": 33,
	"./flags/cn.svg": 34,
	"./flags/de.svg": 35,
	"./flags/es.svg": 36,
	"./flags/fr.svg": 37,
	"./flags/gb.svg": 38,
	"./flags/it.svg": 39,
	"./flags/jp.svg": 40,
	"./flags/us.svg": 41,
	"./icons/arrow-slider.svg": 42,
	"./icons/arrow.svg": 43,
	"./icons/back.svg": 44,
	"./icons/blason.svg": 45,
	"./icons/close.svg": 46,
	"./icons/dotted-line-horizontal.svg": 47,
	"./icons/dotted-line.svg": 48,
	"./icons/download.svg": 49,
	"./icons/error.svg": 50,
	"./icons/facebook.svg": 51,
	"./icons/info.svg": 52,
	"./icons/instagram.svg": 53,
	"./icons/linkedin.svg": 54,
	"./icons/marker.svg": 55,
	"./icons/pinterest.svg": 56,
	"./icons/play.svg": 57,
	"./icons/slider-arrow.svg": 58,
	"./icons/success.svg": 59,
	"./icons/twitter.svg": 60,
	"./icons/weibo.svg": 61,
	"./icons/youtube.svg": 62,
	"./logo.jpg": 63,
	"./map.jpg": 64,
	"./pattern.jpg": 65,
	"./texture.jpg": 66
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 30;